import {RootState} from "../../../../store";

export const getProfileInfoIsLoading = (state: RootState) => state.profileInfoReducer.isLoading;
